module.exports = __webpack_public_path__ + "static/w3-datepicker-navigation-b81be8fdf9576bc504cc8482a600d6a4.gif";